import { useQuery } from '@tanstack/react-query';
import api from '../services/api';

// hooks/useNavbarContent.js
const fallbackNavbarData = {
  code: 200,
  block_status: 0,
  block_reason: '',
  dataset: {
    data: {
      menus: [
        { id: 1, title: 'Home', url: '/', slug: 'home', menu_type: 'link', children: [] },
        { id: 2, title: 'Features', url: '/#features', slug: 'features', menu_type: 'link', children: [] },
        { id: 3, title: 'About Us', url: '/about-us', slug: 'about-us', menu_type: 'link', children: [] },
        { id: 4, title: 'Blog', url: '/blog', slug: 'blog', menu_type: 'link', children: [] },
        { id: 5, title: 'Contact', url: '/contact', slug: 'contact', menu_type: 'link', children: [] },
        { id: 6, title: 'GET STARTED', url: '/get-started', slug: 'get-started', menu_type: 'button', children: [] },
      ],
      logo: '',
      header_custom_css: '',
      header_custom_js: '',
      body_open_custom_css: '',
      body_open_custom_js: '',
      body_close_custom_css: '',
      body_close_custom_js: '',
      theme: { overrides: {}, version: 1 }, // <— NEW
    },
  },
  message: 'Fallback navbar content loaded.',
  error: false,
};

export const useNavbarContent = () => {
  return useQuery({
    queryKey: ['navbarContent'],
    queryFn: async () => {
      const response = await api.get('/web-content/get-navbar');
      return response.data;
    },
    staleTime: 3 * 60 * 1000, // 3 minutes
    cacheTime: 3 * 60 * 1000, // 3 minutes
    refetchOnWindowFocus: false,
    retry: 3,
    placeholderData: fallbackNavbarData,
  });
};
